import { render } from "./high-end-class.vue?vue&type=template&id=33583a40&scoped=true"
import script from "./high-end-class.vue?vue&type=script&lang=js"
export * from "./high-end-class.vue?vue&type=script&lang=js"

import "./high-end-class.vue?vue&type=style&index=0&id=33583a40&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33583a40"]])

export default __exports__